function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { themeSpaces } from '../../../theme/foundations';
export var baseModalTheme = {
  baseStyle: _ref => {
    var {
      isLoading,
      shouldHideCloseButton,
      showBorderTop,
      showBorderBottom,
      hasHeaderContent,
      hasFooterContent
    } = _ref;
    var modalMaxHeight = '80vh';
    return {
      modalContent: {
        minHeight: '248px',
        maxHeight: modalMaxHeight,
        justifyContent: isLoading ? 'center' : 'flex-start',
        padding: 'none',
        overflow: 'hidden',
        zIndex: 'modal'
      },
      header: _objectSpread({
        flexShrink: 0,
        paddingTop: {
          xs: shouldHideCloseButton ? 'm' : "calc(".concat(themeSpaces.m, " + ").concat(themeSpaces.m, ")"),
          s: shouldHideCloseButton ? 'xxl' : "calc(".concat(themeSpaces.xxl, " + ").concat(themeSpaces.xs, ")")
        },
        paddingX: {
          xs: 'm',
          s: 'xxl'
        }
      }, hasHeaderContent && {
        paddingBottom: {
          xs: 's',
          s: 'm'
        }
      }),
      body: _objectSpread(_objectSpread({
        height: '100%',
        width: '100%',
        overflowY: 'auto',
        display: 'flex',
        flexDirection: 'column',
        paddingX: {
          xs: 'm',
          s: 'xxl'
        }
      }, showBorderTop && {
        borderTop: 'basic.light'
      }), showBorderBottom && {
        borderBottom: 'basic.light'
      }),
      footer: _objectSpread({
        flexShrink: 0,
        paddingX: {
          xs: 'm',
          s: 'xxl'
        },
        paddingBottom: {
          xs: 'm',
          s: 'xxl'
        }
      }, hasFooterContent && {
        paddingTop: {
          xs: 'm',
          s: 'xl'
        }
      }),
      closeButton: {
        position: 'absolute',
        top: {
          xs: 's',
          s: 'm'
        },
        right: {
          xs: 's',
          s: 'm'
        },
        zIndex: 'docked'
      }
    };
  },
  sizes: {
    small: {
      modalContent: {
        width: '560px',
        marginX: 'none'
      }
    },
    medium: {
      modalContent: {
        width: {
          s: '100%',
          l: '858px'
        },
        marginX: {
          s: 'xxl',
          l: 'none'
        }
      }
    },
    large: {
      modalContent: {
        width: '100%',
        marginX: 'xxl'
      }
    }
  }
};
//# sourceMappingURL=BaseModal.theme.js.map